import styled, { css } from 'styled-components';
import { B as Box } from '../Box/Box-C6wMSC3s.js';

/* eslint-disable import/prefer-default-export */
const FlexBox = /*#__PURE__*/styled(Box).withConfig({
  componentId: "sc-storm-ui-40021409__sc-nae1j8-0"
})(["display:flex;border-radius:unset;", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], ({
  $direction
}) => css(["flex-direction:", ";"], $direction), ({
  $alignContent
}) => css(["align-content:", ";"], $alignContent), ({
  $justifyContent
}) => css(["justify-content:", ";"], $justifyContent), ({
  $alignItems
}) => css(["align-items:", ";"], $alignItems), ({
  theme,
  $columnGap
}) => {
  var _theme$spacing;
  return css(["column-gap:", ";"], (_theme$spacing = theme.spacing[$columnGap]) === null || _theme$spacing === void 0 ? void 0 : _theme$spacing.default);
}, ({
  theme,
  $rowGap
}) => {
  var _theme$spacing2;
  return css(["row-gap:", ";"], (_theme$spacing2 = theme.spacing[$rowGap]) === null || _theme$spacing2 === void 0 ? void 0 : _theme$spacing2.default);
}, ({
  $wrap
}) => css(["flex-wrap:", ";"], $wrap), ({
  $shrink
}) => css(["flex-shrink:", ";"], $shrink), ({
  $grow
}) => css(["flex-grow:", ";"], $grow), ({
  $basis
}) => css(["flex-basis:", ";"], $basis));

export { FlexBox as F };
//# sourceMappingURL=Flex.styles-DSJAaEfY.js.map
